{
  "pageTitle": "Panel klientów",
  "pageSubtitle": "Zarządzanie reklamodawcami",
  "search": {
    "placeholder": "Szukaj po nazwie..."
  },
  "table": {
    "name": "Nazwa",
    "actions": ""
  },
  "actions": {
    "addClient": "Dodaj klienta",
    "edit": "Edytuj",
    "archive": "Archiwizuj",
    "cancel": "Anuluj",
    "save": "Zapisz",
    "saving": "Zapisywanie...",
    "saved": "Zapisano",
    "saveFailed": "Nie udało się zapisać klienta",
    "archived": "Klient został zarchiwizowany"
  },
  "dialog": {
    "createTitle": "Nowy klient",
    "editTitle": "Edytuj klienta",
    "archiveTitle": "Archiwizuj klienta",
    "archiveDescription": "Ta operacja jest nieodwracalna. Klient zostanie ukryty z listy.",
    "close": "Zamknij",
    "fields": {
      "acronym": "Akronim",
      "acronymPlaceholder": "np. VM",
      "acronymRequired": "Akronim jest wymagany",
      "acronymTooLong": "Akronim jest za długi",
      "acronymInvalidChar": "Akronim nie może zawierać znaku „/”",
      "acronymTaken": "Klient z tym akronimem już istnieje",
      "addBrand": "Dodaj brand",
      "brandPlaceholder": "Nazwa brandu",
      "brandRequired": "Brand nie może być pusty",
      "brands": "Brandy",
      "brandsHint": "Dodaj opcjonalne brandy przypisane do klienta.",
      "name": "Nazwa",
      "nameRequired": "Nazwa jest wymagana",
      "nameTaken": "Klient o tej nazwie już istnieje",
      "namePlaceholder": "Nazwa klienta",
      "notes": "Notatki",
      "notesPlaceholder": "Dodatkowe informacje...",
      "noBrands": "Brak brandów",
      "removeBrand": "Usuń"
    },
    "suggestions": {
      "heading": "Istniejący klienci",
      "noResults": "Brak wyników"
    }
  },
  "details": {
    "brands": "Brandy",
    "emptyValue": "Brak",
    "notes": "Notatki",
    "title": "Szczegóły klienta"
  },
  "permissionDenied": "Nie masz uprawnień do tej strony.",
  "empty": {
    "title": "Brak klientów",
    "description": "Dodaj pierwszego klienta."
  }
}
